import { Link, NavLink, useLocation } from "react-router-dom";
import { Download } from "lucide-react";
import { BrandIcon, TAGLINE } from "@/components/Brand";

const links = [
  { to: "/join", label: "Memberships" },
  { to: "/partnerships", label: "Partnerships" },
];

// App Store / Play Store anti-steering (Guideline 3.1.1): on legal & compliance
// routes the logo must not navigate to the sales root, and no purchase links show.
const COMPLIANCE_PREFIXES = [
  "/privacy",
  "/terms",
  "/security",
  "/account/delete",
  "/account-deletion",
  "/delete-account",
  "/delete",
  "/support",
];

const BrandContent = () => (
  <>
    <BrandIcon className="h-9 w-auto object-contain transition-transform duration-300 group-hover:scale-105" />
    <span className="flex flex-col leading-none">
      <span className="font-heading text-2xl font-extrabold tracking-tight text-white leading-none select-none">
        Spark<span className="text-[#F43F5E]">d</span>
      </span>
      <span className="hidden sm:block mt-1 text-[9px] uppercase tracking-[0.22em] text-slate-400">
        {TAGLINE}
      </span>
    </span>
  </>
);

export const Navbar = () => {
  const { pathname } = useLocation();
  const isCompliance = COMPLIANCE_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`) || pathname.startsWith(p)
  );

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#0F172A]/80 border-b border-white/[0.08]">
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between gap-4">
        {isCompliance ? (
          <div data-testid="nav-logo-static" className="flex items-center gap-2.5 shrink-0 select-none cursor-default">
            <BrandContent />
          </div>
        ) : (
          <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5 shrink-0 group">
            <BrandContent />
          </Link>
        )}

        {!isCompliance && (
          <div className="hidden md:flex items-center gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `px-3 py-2 rounded-xl text-sm font-medium transition-colors ${
                    isActive
                      ? "text-[#F43F5E] bg-white/[0.06]"
                      : "text-slate-300 hover:text-white hover:bg-white/5"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        )}

        {!isCompliance && (
          <Link
            to="/download"
            data-testid="nav-download-cta"
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-2xl text-sm font-semibold text-white spark-gradient spark-gradient-hover transition-all active:scale-95 shrink-0"
          >
            <Download className="w-4 h-4" /> Download App
          </Link>
        )}
      </nav>
    </header>
  );
};
